module.exports = __webpack_public_path__ + "media/images/countryrect/td-08bcb295917b07aeb1a8853534f85e14.svg";